export default __webpack_public_path__ + "static/media/arrow-left.68feed25.svg";